import { formatLiveMatchLabel } from './LiveMatchPanel';
import { useI18n } from '../../i18n';

export const MAX_COURTS = 50;

/** 「경기 시작」할 코트 선택. 진행 중인 코트를 고르면 그 코트의 경기를 바꾼다 */
function CourtPickerModal({
  open,
  title,
  liveMatches,
  selectedTournamentId,
  courtCount,
  onChangeCourtCount,
  onPick,
  onClose,
}) {
  const { t } = useI18n();
  if (!open) return null;

  const busyMax = Math.max(0, ...(liveMatches ?? []).map((live) => live.court));
  const courts = Array.from({ length: Math.max(courtCount, busyMax) }, (_, i) => i + 1);
  const liveOf = (court) => liveMatches?.find((live) => live.court === court);

  return (
    <div className="modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="court-picker-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div>
            <p className="modal-eyebrow">COURT</p>
            <h2 id="court-picker-title" className="modal-title">
              {t('bracket.courtPicker.title')}
            </h2>
            <p className="modal-subtitle">{title}</p>
          </div>
          <button type="button" className="modal-close" onClick={onClose} aria-label={t('common.close')}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <label className="court-count">
            {t('bracket.courtPicker.courtCount')}
            <input
              type="number"
              className="form-input"
              min={1}
              max={MAX_COURTS}
              value={courtCount}
              onChange={(e) => {
                const value = Math.round(Number(e.target.value));
                if (Number.isFinite(value)) onChangeCourtCount(Math.min(MAX_COURTS, Math.max(1, value)));
              }}
            />
          </label>
          <div className="court-grid">
            {courts.map((court) => {
              const live = liveOf(court);
              return (
                <button
                  key={court}
                  type="button"
                  className={`court-option${live ? ' court-option-busy' : ''}`}
                  onClick={() => onPick(court, live)}
                >
                  <strong>{t('bracket.live.court', { court })}</strong>
                  <span>
                    {live
                      ? t('bracket.courtPicker.busy', {
                          match: formatLiveMatchLabel(t, live, selectedTournamentId),
                        })
                      : t('bracket.courtPicker.free')}
                  </span>
                </button>
              );
            })}
          </div>
          <p className="score-hint">{t('bracket.courtPicker.hint')}</p>
        </div>
      </div>
    </div>
  );
}

export default CourtPickerModal;
